import DataTablePublic from '@/components/common/DataTablePublic'
import { request } from '@/request'
import { PublicHeader } from '../../../components/common/'

export default {
  name: 'Materiais',
  components: {
    DataTablePublic,
    PublicHeader
  },
  data() {
    return {
      model: {
        columns: [
          {
            name: 'referencia',
            sortField: 'referencia',
            title: 'Código',
            dataClass: 'align-left nowrap',
            filterable: true
          },
          {
            name: 'medida.nome',
            title: 'Medida',
            dataClass: 'align-left',
            filterable: true
          },
          {
            name: 'nome',
            title: 'Material',
            dataClass: 'align-left',
            filterable: true
          },
          {
            name: 'descricao',
            title: 'Descrição do Material',
            dataClass: 'align-left',
            filterable: true
          },
          {
            name: 'subgrupo.grupo.nome',
            title: 'Grupo',
            dataClass: 'align-left',
            filterable: true
          },
          {
            name: 'subgrupo.nome',
            title: 'Subgrupo',
            dataClass: 'align-left',
            filterable: true
          }
        ],
        lista_medidas: [],
        lista_grupos: [],
        lista_subgrupos: [],
        filters: {
          referencia: '',
          pesquisa: '',
          descricao: '',
          medida: '',
          grupo: '',
          subgrupo: ''
        }
      }
    }
  },
  methods: {
    consultar: _.debounce(function(grupo = '') {
      if (grupo) {
        this.model.filters.subgrupo = null
        this.subgrupos()
      }

      this.$refs.dt.refresh()
    }, 1000),

    medidas() {
      request
        .get('materiais/lista-medidas')
        .then(response => {
          this.model.lista_medidas = response.data
        })
        .catch(response => {
          console.log(response)
        })
    },

    grupos() {
      request
        .get('materiais/listar-grupos')
        .then(response => {
          this.model.lista_grupos = response.data
        })
        .catch(response => {
          console.log(response)
        })
    },

    subgrupos() {
      request
        .get(
          'materiais/listar-subgrupos?grupo=' +
            (this.model.filters.grupo ? this.model.filters.grupo : '')
        )
        .then(response => {
          this.model.lista_subgrupos = response.data
        })
        .catch(response => {
          console.log(response)
        })
    },

    exportar() {
      return `${this.$root.$data.apiUrl}materiais/lista-material?exportar=true`
    }
  },
  mounted() {
    this.medidas()
    this.grupos()
    this.subgrupos()
  }
}



// WEBPACK FOOTER //
// ./src/views/public/materiais/materiais.js